import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('melati_jwt'));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('melati_user')); } catch (_) { return null; }
  });
  const [checking, setChecking] = useState(Boolean(token));

  const saveSession = (authorization, account) => {
    localStorage.setItem('melati_jwt', authorization.token);
    localStorage.setItem('melati_user', JSON.stringify(account));
    setToken(authorization.token);
    setUser(account);
  };

  const login = async (credentials) => {
    const { data } = await api.post('/auth/login', credentials);
    saveSession(data.data.authorization, data.data.user);
    return data.data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    saveSession(data.data.authorization, data.data.user);
    return data.data.user;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch (_) { /* token tetap dibersihkan */ }
    localStorage.removeItem('melati_jwt');
    localStorage.removeItem('melati_user');
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    if (!token) { setChecking(false); return; }
    api.get('/auth/me')
      .then(({ data }) => {
        const account = data.data;
        localStorage.setItem('melati_user', JSON.stringify(account));
        setUser(account);
      })
      .catch(() => {
        localStorage.removeItem('melati_jwt');
        localStorage.removeItem('melati_user');
        setToken(null);
        setUser(null);
      })
      .finally(() => setChecking(false));
  }, [token]);

  const value = { token, user, checking, login, register, logout };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
